import {
  DndContext,
  closestCenter,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import WorkoutCard from "../WorkoutCard";

export default function UnassignedWorkoutsList({
  unassignedWorkouts,
  hasPrograms,
  getPhaseTitle,
  exerciseLibrary,
  userMappings,
  onEdit,
  onDelete,
  onCopy,
  onSaveAsTemplate,
  onDragEnd,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(KeyboardSensor)
  );

  if (unassignedWorkouts.length === 0) return null;

  return (
    <div>
      {hasPrograms && <p className="label-overline mb-3">SCHEDE SENZA PROGRAMMA</p>}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={(e) => onDragEnd("", e)}
      >
        <SortableContext
          items={unassignedWorkouts.map((w) => w.id)}
          strategy={verticalListSortingStrategy}
        >
          <div className="space-y-3">
            {unassignedWorkouts.map((w) => (
              <WorkoutCard
                key={w.id}
                workout={w}
                getPhaseTitle={getPhaseTitle}
                exerciseLibrary={exerciseLibrary}
                userMappings={userMappings}
                onEdit={onEdit}
                onDelete={onDelete}
                onCopy={onCopy}
                onSaveAsTemplate={onSaveAsTemplate}
                sortable
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
}
